/*
 * SOLVEY · ad auto-add-to-cart
 * --------------------------------------------------------------------------
 * Wanneer een bezoeker via een ad-discount-link binnenkomt
 * (/discount/CODE?redirect=/products/HANDLE?solvey_autocart=1) wordt het
 * product van die pagina automatisch in de winkelmand gelegd en opent de
 * quick-cart drawer met het item + de 10% korting zichtbaar. De korting uit
 * de discount-cookie wordt door Shopify automatisch op de cart toegepast
 * (geverifieerd op /cart.js).
 *
 * Marker = query-param `solvey_autocart=1` (overleeft de discount-redirect en
 * de Weglot /nl/-prefix-redirect).
 *
 * WAAROM een reload i.p.v. een event dispatchen:
 *   De quick-cart drawer wordt server-side gerenderd; het thema ververst 'm
 *   via een MODULE-PRIVATE event-bus (theme.js `r$1('quick-cart:updated')`)
 *   die van buitenaf niet bereikbaar is. Een DOM-event dispatchen doet niets.
 *   Daarom: na de AJAX-add de pagina één keer herladen met een schone URL —
 *   dan rendert het thema de drawer vers MET het item (alle qty/verwijder/
 *   checkout-bindings intact) — en openen we 'm via de bestaande cart-trigger.
 *
 * Flow:
 *   Fase 1 (marker aanwezig): variant ophalen -> /cart/add.js -> open-vlag
 *     in sessionStorage -> marker uit URL strippen + reload.
 *   Fase 2 (geen marker, open-vlag gezet): cart-trigger klikken zodat de
 *     vers-gerenderde drawer opent; vlag wissen.
 *
 * Re-add-beveiliging zit in het STRIPPEN van de marker (niet in sessionStorage)
 * zodat het ook in private mode niet dubbel toevoegt of in een loop raakt.
 */
(function () {
  'use strict';

  var PARAM = 'solvey_autocart';
  var OPEN_FLAG = 'solvey_autocart_open';

  function getMarker() {
    try {
      return new URLSearchParams(window.location.search).get(PARAM);
    } catch (e) {
      return null;
    }
  }

  function reloadWithoutMarker() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete(PARAM);
      window.location.replace(url.pathname + url.search + url.hash);
    } catch (e) {
      window.location.reload();
    }
  }

  // --- Fase 2: drawer openen na de reload ---------------------------------
  function openDrawerAfterReload() {
    var flag;
    try { flag = sessionStorage.getItem(OPEN_FLAG); } catch (e) {}
    if (flag !== '1') return;
    try { sessionStorage.removeItem(OPEN_FLAG); } catch (e) {}

    var tries = 0;
    (function attempt() {
      tries++;
      var wrapper = document.querySelector('.quick-cart__wrapper');
      if (wrapper && wrapper.classList.contains('active')) return; // al open
      var trigger = document.querySelector('[data-solvey-cart-trigger]');
      if (trigger) trigger.click();
      if (tries < 24) setTimeout(attempt, 250); // ~6s ruimte voor theme-init
    })();
  }

  // --- Fase 1: item toevoegen en herladen ---------------------------------
  function addThenReload() {
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) {
      reloadWithoutMarker();
      return;
    }
    var handle = match[1];

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variants = (product && product.variants) || [];
        var variant = variants.filter(function (v) { return v.available; })[0] || variants[0];
        if (!variant) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
      })
      .then(function (r) { return r ? r.json() : null; })
      .then(function (res) {
        if (res && !res.status) {
          try { sessionStorage.setItem(OPEN_FLAG, '1'); } catch (e) {}
        }
        reloadWithoutMarker();
      })
      .catch(function () {
        reloadWithoutMarker();
      });
  }

  function run() {
    if (getMarker() === '1') {
      addThenReload();
    } else {
      openDrawerAfterReload();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
